import React from 'react';
import {copyright_policy} from "../assets/policy/copyright_policy";
import {personal_policy} from "../assets/policy/personal_policy";
import {term_policy} from "../assets/policy/term_policy";
import {youth_policy} from "../assets/policy/youth_policy";
import {ethics_policy} from "../assets/policy/ethics_policy";

const Policy = () => {
    const policy = window.location.pathname.split('/')[2]

    const iframePart = (policy) => {
        if(policy === 'copyright_policy'){
            return {
                __html: copyright_policy,
            };
        }else if( policy === 'personal_policy'){
            return {
                __html: personal_policy,
            };
        }else if( policy === 'youth_policy'){
            return {
                __html: youth_policy,
            };
        }else if( policy === 'ethics_policy'){
            return {
                __html: ethics_policy,
            };
        }else {
            return {
                __html: term_policy,
            };
        }
    };


    return (
        <>
            {policy && <div
                className='inner_container'
                dangerouslySetInnerHTML={iframePart(policy)}
                style={{margin: '3rem auto', lineHeight:'1.5'}}
            />}
        </>
    );
};

export default Policy;
